import React from 'react';

const round10 = (number = 0, exp = 0) => {
  return number.toFixed(exp);
}
const StructureDescription = (props) => {
  const { structure } = props;
  return (
    <div className="row no-gutters">
      <div className="col col-sm-12 col-lg-12 col-xl-6 pr-3 pl-3 pt-2 pb-2">

        <div className="row no-gutters">
          <div className="col text-muted">Space group:</div>
          <div className="col text-dark"><b>{structure.spaceGroupInfo ?
            <span>{structure.spaceGroupInfo[0]} ({structure.spaceGroupInfo[1]})</span>
          : null}</b></div>
        </div>
        <div className="row no-gutters">
          <div className="col text-muted">Unit cell volume:</div>
          <div className="col text-dark"><b>{round10(structure.volume, 2)} Å<sup>3</sup></b></div>
        </div>
        <div className="row no-gutters">
          <div className="col text-muted">Factor Z:</div>
          <div className="col text-dark"><b>  {structure.factor}</b></div>
        </div>
        {structure.oxiStateGuesses && structure.oxiStateGuesses[0] ?
          <div className="row no-gutters">
            <div className="col text-muted">OxiState guesses:</div>
            <div className="col text-dark"><ul>
              {Object.keys(structure.oxiStateGuesses[0]).map(key => <li key={key}>{key}: {structure.oxiStateGuesses[0][key]}</li>)}
            </ul></div>
          </div>
        : null }
      </div>
      <div className="col col-sm-12 col-lg-12 col-xl-6">
        <table className="table table-sm text-right no-margin border-top-0">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-center border-bottom border-top-0" colSpan="5">Lattice parameters</th>
            </tr>
          </thead>
          {structure.lattice ?
            <tbody>
              <tr>
                <th className="text-muted">a</th>
                <td className="text-dark">{round10(structure.lattice.abc.a, 4)} Å</td>
                <td className="separator"><div/></td>
                <th className="text-muted">α</th>
                <td className="text-dark">{round10(structure.lattice.angles.α, 2)} °</td>
              </tr>
              <tr>
                <th className="text-muted">b</th>
                <td className="text-dark padding-right">{round10(structure.lattice.abc.b, 4)} Å</td>
                <td className="separator"><div/></td>
                <th className="text-muted">β</th>
                <td className="text-dark">{round10(structure.lattice.angles.β, 2)} °</td>
              </tr>
              <tr>
                <th className="text-muted">c</th>
                <td className="text-dark padding-right">{round10(structure.lattice.abc.c, 4)} Å</td>
                <td className="separator"><div/></td>
                <th className="text-muted">γ</th>
                <td className="text-dark">{round10(structure.lattice.angles.γ, 2)} °</td>
              </tr>
            </tbody>
          : null }
        </table>
      </div>
    </div>
  );
}

export default StructureDescription;



// WEBPACK FOOTER //
// ./src/containers/structures/structureDescription.js